import React from 'react';
import type { TBoardTab } from 'types/insuranceBilling';
import { BOARD_TABS } from './statusConfig';
import s from './s.module.less';

// 表格上方的分段 tabs（原型 09/25）：按 claim 的旅程切 —— Klarity preparation →
// Submitted to clearinghouse → Submitted to payer → Completed，外加 Needs attention。
// 计数来自 summary.tabs（全集口径，不随列筛选变化）。计数为 0 的 chip 点了只会得到空表，
// 所以置灰不可点；summary 还没回来时只显示名称、不置灰。
// 六个 chip 独占一行：页面动作（Add / Settings / Report）10/05 起挪到了页面标题行。
type Props = {
    counts: Record<TBoardTab, number> | null;
    active: TBoardTab;
    onChange: (key: TBoardTab) => void;
    // 有任何筛选生效时出现，一键回到未筛选状态
    showClear: boolean;
    onClear: () => void;
};

const SegmentChips = ({ counts, active, onChange, showClear, onClear }: Props) => (
    <div className={s.segRow}>
        {BOARD_TABS.map((seg) => {
            const n = counts ? counts[seg.key] : null;
            const off = n === 0 && seg.key !== 'all';
            return (
                <button
                    key={seg.key}
                    type="button"
                    className={`${s.segChip} ${active === seg.key ? s.segChipOn : ''} ${off ? s.segChipOff : ''}`}
                    disabled={off}
                    onClick={() => onChange(seg.key)}
                >
                    {seg.label}
                    {n != null && (
                        <>
                            {' '}
                            (<span className={seg.key === 'attention' && n > 0 ? s.segChipRed : ''}>{n}</span>)
                        </>
                    )}
                </button>
            );
        })}
        <span className={s.filterSpacer} />
        {showClear && (
            <button type="button" className={s.clearFilters} onClick={onClear}>
                Clear filters
            </button>
        )}
    </div>
);

export default SegmentChips;
